import { render, staticRenderFns } from "./indexModel.vue?vue&type=template&id=eb72d47a&scoped=true"
import script from "./indexModel.vue?vue&type=script&lang=js"
export * from "./indexModel.vue?vue&type=script&lang=js"
import style0 from "./indexModel.vue?vue&type=style&index=0&id=eb72d47a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb72d47a",
  null
  
)

export default component.exports